module.exports = __webpack_public_path__ + "static/media/photoArticle1.c571273e.jpg";